import axios from 'axios';

class Config {
	constructor() {
		this.apiUrl = process.env.VUE_APP_API_URL;

		console.log('----------------------------------------------------------------------');
		console.log(' Interface Service Web App');
		console.log(` url:                  ${location.toString()}`);
		console.log(` apiUrl:               ${this.apiUrl}`);
		console.log(` host:                 ${location.host}`);
		console.log(` NODE_ENV:             ${process.env.NODE_ENV}`);
		console.log(` BaseURL:              ${process.env.BASE_URL}`);
		console.log('----------------------------------------------------------------------');
	}
}

export default new Config();
